import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { Typography } from '@mui/material';
import { styled } from '@mui/material';
import { colors } from '../styles/globalStyles';
import { getAllCompaniesData } from '../api/adminPanel';
import CompanyCard from '../components/pages/adminPanel/companyCard';
import data from '../data/data.json';
import { selectedLanguageAtom } from '../recoil/atoms/languageAtom';
import { useRecoilValue } from 'recoil';

const Title = styled(Typography)({
    fontSize: 24,
    '& .accent': {
        color: colors.main,
    },
});

const CompaniesWrap = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: 17,
});
const AdminPanel = () => {
    const selectedLanguage = useRecoilValue(selectedLanguageAtom);
    const { adminPanel } = data[selectedLanguage];
    const [companiesData, setCompaniesData] = useState(null);

    useEffect(() => {
        getAllCompaniesData()
            .then((r) => {
                setCompaniesData(r.data);
            })
            .catch((err) => {
                console.error('Ошибка получения данных компаний', err);
            });
    }, []);

    useEffect(() => {
        if (!window.Telegram?.WebApp?.initDataUnsafe?.user?.id) {
            return;
        }
    }, []);

    return (
        <Layout>
            <Title variant={'h2'}>
                {adminPanel.mainTitle} <span className={'accent'}> {adminPanel.accentTitle}</span>
            </Title>
            <CompaniesWrap>
                {companiesData?.map((company) => (
                    <CompanyCard data={company} key={company.name} />
                ))}
            </CompaniesWrap>
        </Layout>
    );
};

export default AdminPanel;
